import { css } from '@emotion/css';

import { Colors, LARGE_DEVICE_MQ, Spacing } from 'apps/shared/scripts/styles/constants';

export const footerClassName = css({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: 'auto',
  paddingTop: '33.3333%',
  paddingBottom: Spacing['2XL'],
  width: '100%',
  [LARGE_DEVICE_MQ]: {
    paddingTop: Spacing['3XL'],
    paddingBottom: Spacing['3XL'],
  }
});

export const progressClassName = css({});

export const progressBarClassName = css({
  '--bs-progress-bar-bg': `${'#0d99ff'} !important`,
  height: `${8}px !important`,
  width: 130,
});

export const ctaClassName = css({
  display: 'flex',
  alignSelf: 'flex-end',
  flex: 1,
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: Spacing.XS,
  color: Colors.Secondary,
});
